module.exports = __webpack_public_path__ + "media/images/front/icon_like_on-af5d68fac3834ad7699b4071d3e5170b.png";